(() => {
  function bindForms(root=document){
    root.querySelectorAll('form').forEach(form=>{
      if(form.id==='EdelmanConfiguratorForm'||form.querySelector('[name="form_type"]')?.value!=='contact'||form.dataset.ewDraftBound)return;
      form.dataset.ewDraftBound='true';
      const key=`edelman-contact-v131:${location.pathname}:${form.id}`;
      const fields=()=>[...form.querySelectorAll('input:not([type="hidden"]),textarea,select')].filter(el=>el.name);
      let draft=null;try{draft=JSON.parse(sessionStorage.getItem(key)||'null');}catch{}
      const result=form.querySelector('[data-form-result]')?.dataset.formResult;
      if(draft&&Date.now()-draft.at<1800000&&result==='error'){
        fields().forEach(el=>{if(typeof draft.fields[el.name]==='string')el.value=draft.fields[el.name];});
      }
      if(result==='success'){try{sessionStorage.removeItem(key);}catch{}}
      form.addEventListener('submit',()=>{
        try{sessionStorage.setItem(key,JSON.stringify({at:Date.now(),fields:Object.fromEntries(fields().map(el=>[el.name,el.value]))}));}catch{}
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>bindForms(),{once:true});else bindForms();
  document.addEventListener('shopify:section:load',event=>bindForms(event.target));
})();
